/**
 * App Configuration Constants
 */

export const APP_CONFIG = {
  // Domain
  DOMAIN_URL: 'https://alltuc.com',

  // Contact Info (from alltucConstants)
  CONTACT: {
    phone: '+54 381 555-0000',
    email: 'ventas@alltuc.com',
    paymentsEmail: 'pago@alltuc.com',
    supportEmail: 'soporte@alltuc.com',
    whatsapp: '+54 9 381 555-0000',
    address: 'San Miguel de Tucumán, Tucumán, Argentina'
  },

  // Theme Colors (from alltucConstants)
  THEME: {
    primaryColor: '#e66e19',
    secondaryColor: '#fdba74',
    accentColor: '#ffffff',
    backgroundColor: '#f5f5f4',
    textColor: '#0c0a09'
  },

  // Payment Provider Colors
  PAYMENT_COLORS: {
    mercadoPago: '#009EE3',
    card: '#2563eb', // blue-600
    cash: '#16a34a', // green-600
  },

  // Gamification
  CURRENCY_PER_POINT: 100,
  REWARD_REDEMPTION_DELAY_MS: 1000,

  // Checkout & Cart Security
  FREE_SHIPPING_THRESHOLD: 20000,
  MAX_QTY_PER_ITEM: 10,

  // Injections & Layout
  CATALOG_INJECTION_INTERVAL: 12,
  BANNER_ASPECT_RATIO: '16/9',

  // Magic Strings
  COUPON_FREE_SHIPPING: 'ENVIO-GRATIS',

  // Logistics
  LOGISTICS: {
    LOCAL_ZIP_START: 4000,
    LOCAL_ZIP_END: 4999
  }
} as const;

// ============================================
// MARKETING & BENEFITS
// ============================================

export interface BenefitItem {
  icon: string;
  title: string;
  desc: string;
  color: string;
}

export const MOCK_BENEFITS: BenefitItem[] = [
  { icon: 'sensors', title: 'Acceso a LIVE', desc: 'Eventos exclusivos y drops en vivo.', color: 'text-red-500 bg-red-500/10' },
  { icon: 'card_giftcard', title: 'Club Puntos', desc: 'Suma TucCoins y canjealos por premios.', color: 'text-purple-500 bg-purple-500/10' },
  { icon: 'local_shipping', title: 'Envíos Rápidos', desc: 'Procesamiento prioritario en tus pedidos.', color: 'text-blue-500 bg-blue-500/10' },
  { icon: 'verified_user', title: 'Compra Segura', desc: 'Garantía oficial y soporte personalizado.', color: 'text-green-500 bg-green-500/10' },
];

// ============================================
// ALLTUC OFFICIAL SHOP
// ============================================

export const ALLTUC_SHOP_ID = 'shop_alltuc';
export const ALLTUC_PARTNER_ID = 'superadmin_partner';
export const ALLTUC_SHOP_SLUG = 'alltuc-oficial';
export const ALLTUC_SHOP_SLUG_ALT = 'alltuc';

export const ALLTUC_SHOP_INFO = {
  id: ALLTUC_SHOP_ID,
  partnerId: ALLTUC_PARTNER_ID,
  slug: ALLTUC_SHOP_SLUG,
  alternateSlug: ALLTUC_SHOP_SLUG_ALT,
  name: 'AllTuc Oficial',
  description: 'La tienda oficial de AllTuc. Productos nuevos con garantía y envío express en Tucumán.',
  shortDescription: 'Productos nuevos con garantía AllTuc',
  isOfficial: true,
  isVerified: true,
} as const;

// ============================================
// STORAGE KEYS
// ============================================

export const STORAGE_KEYS = {
  CART: 'alltuc_cart',
  FAVORITES: 'alltuc_favorites',
  RECENT_SEARCHES: 'alltuc_recent_searches',
  USER_PREFERENCES: 'alltuc_user_preferences',
  THEME: 'alltuc_theme',
  LANGUAGE: 'alltuc_language',
  VIEWED_PRODUCTS: 'alltuc_viewed_products',
  ONBOARDING_COMPLETE: 'alltuc_onboarding_complete',
  COOKIE_ACCEPTED: 'alltuc_cookie_accepted'
} as const;

// Alias for backward compatibility
export const LOCAL_STORAGE_KEYS = STORAGE_KEYS;
